<template>
  <score-main @back="goBack">
    <template slot="nav">
      <div class="scoreNav">
        <p>
          <span v-if="classInfo.is_special_train === 1">【快】</span>
          {{ classInfo.class_name }}理论答卷
        </p>
      </div>
    </template>
    <template slot="main">
      <div class="scoreMain">
        <div class="content">
          <div
            v-if="formVal.length"
            class="scrollArea"
            :class="{ 'five-scrollArea': isFive }"
          >
            <vue-scroll :ops="ops">
              <div class="table">
                <div
                  v-for="(item, index) in formVal"
                  :key="index"
                  :class="{
                    item: true,
                    exam_border: item.border,
                    item_border: true,
                  }"
                >
                  <div class="row up" style="border-bottom: none">
                    <!-- row -->
                    <div class="col user">
                      <div class="num">
                        {{ index + 1 }}
                      </div>
                      <img
                        :src="item.user_profile_picture || User"
                        alt=""
                        @error="userImgError(index)"
                        @click="viewDetail(item.uid)"
                      />
                      <div class="wrap">
                        <p class="name" style="margin-bottom:0">{{ item.user_name }}</p>
                      </div>
                    </div>
                    <div class="col info">
                      <div class="title">
                        <p>基</p>
                        <p>本</p>
                        <p>信</p>
                        <p>息</p>
                      </div>
                      <div class="block">
                        <div class="line">
                          <p>证件号：{{ item.id_number }}</p>
                        </div>
                        <div class="line">
                          <p>
                            <span>性别 : {{ item.gender | getGender }}</span>
                            <span>手机 : {{ item.mobile_phone }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col switch-wrapper">
                      <div class="title" style="width:40px">
                        <p>是否</p>
                        <p>参加</p>
                        <p>理论</p>
                        <p>考试</p>
                      </div>
                      <div class="btns">
                        <el-switch
                          v-model="item.isUploadFile"
                          size="mini"
                          active-color="#4cd964"
                          active-text="是"
                          inactive-color="#ccc"
                          inactive-text="否"
                          @change="handleSwitchChange(item.isUploadFile, index)"
                        ></el-switch>
                      </div>
                    </div>
                    <div class="col note" v-if="!item.isUploadFile">
                      <div class="title">
                        <p>未</p>
                        <p>考</p>
                        <p>试</p>
                        <p>原</p>
                        <p>因</p>
                      </div>
                      <textarea
                        v-model="item.reason"
                        :placeholder="note"
                        @blur="checkNoteEmpty(item)"
                      ></textarea>
                      <p v-if="item.isNoteEmpty" class="err-tips">
                        请填写未考试原因
                      </p>
                    </div>
                    <div class="col upload-wrapper" v-else>
                      <div class="title">
                        <p>上</p>
                        <p>传</p>
                        <p>答</p>
                        <p>卷</p>
                      </div>
                      <div class="upload-content">
                        <el-upload
                          :action="uploadAction"
                          :on-remove="
                            (file, fileList) =>
                              handleSocreDocRemove(file, fileList, index)
                          "
                          :limit="1"
                          :headers="fileUpHeaders"
                          :data="fileUpParam"
                          :on-exceed="
                            (file, fileList) =>
                              handleScoreDocUoloadCheck(file, fileList, index)
                          "
                          :file-list="item.fileList"
                          :before-upload="(file) => beforeUpload(file)"
                          :on-success="
                            (res, file) => {
                              handleUploadScoreSuccess(res, file, index);
                            }
                          "
                        >
                          <el-button size="mini" type="primary"
                            >点击上传</el-button
                          >
                          <div slot="tip" class="el-upload__tip">
                            只能上传1个pdf文件，且不超过50M
                          </div>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
        <div class="btns">
          <div class="btn success" @click="handlePageAction('save')">
            {{ role_type === "teaFive" ? "暂时保存" : "保存" }}
          </div>
          <div class="btn success" @click="handlePageAction('back')">
            上一步
          </div>
          <div class="btn success" @click="handlePageAction('next')">
            下一步(培训班报告)
          </div>
          <div class="btn error" @click="cancelBack">取消</div>
        </div>
        <!-- <yioks-tips :tips="backWarn.tips"
                    :showTips="backWarn.flag"
                    @hideTips="hideBackTips"></yioks-tips> -->
        <yioks-tips
          :tips="'确定放弃修改并返回吗？'"
          :showTips="isConfirmBackDialog"
          @hideTips="hideBackTips"
        ></yioks-tips>

        <yioks-tips
          :tips="'确认保存，并进入下一步吗？'"
          :showTips="isConfirmSummitDialog"
          @hideTips="hideSummitTips"
        ></yioks-tips>
        <yioks-tips
          :tips="'确认保存，并返回上一步吗？'"
          :showTips="isConfirmFanhuiDialog"
          @hideTips="hideFanhuiTips"
        ></yioks-tips>
        <yioks-tips :tips="'确定放弃修改并返回吗？'"
          :showTips="isCancel"
          @hideTips="hideCanCelTips"></yioks-tips>
        <yioks-tips
          :tips="'确认暂时保存？'"
          :showTips="isSaveTemp"
          @hideTips="handleSaveTemp"
        ></yioks-tips>
      </div>
    </template>
  </score-main>
</template>

<script>
import scoreMixin from "@/minix/score";
import ops from "@/assets/js/vuescrollOption";
import User from "@/assets/images/person.png";
import fiveMixins from "@/minix/fiveMixins";
import { storageData } from "@/assets/js/storage";
import {
  getFiveScoreInfo,
  postFiveStuScoreDoc,
} from "@/api/training_teacher/api";
import uploadMixin from "@/minix/uploadMixin";
import qs from "qs";
export default {
  name: "upload-score",
  // mixins: [fiveMixins ,scoreMixin],
  mixins: [fiveMixins, uploadMixin],
  components: {
    "score-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
  },
  data() {
    return {
      User,
      isSaveTemp: false,
      isConfirmSummitDialog: false,
      isConfirmFanhuiDialog: false,
      isCancel:false,
      isConfirmBackDialog: false,
      ifDiaShow: false,
      pageActionStatus: "next",
      classInfo: {},
      formVal: [],
      ops: ops(),
      note: "请输入未考试原因",
    };
  },

  computed: {
    c_id() {
      const { c_id } = this.$route.query;
      return c_id || "";
    },
    role_type() {
      const role_type = storageData.getUserType();
      return role_type;
    },
  },

  filters: {
    getGender(gender) {
      return gender === "Male" ? "男" : "女";
    },
  },

  mounted() {
    this.loadStuList();
  },

  methods: {
    setRequiredFlag() {
      this.formVal = this.formVal.map((item) => {
        const { fileData, ...other } = item;
        let obj = {
          ...other,
          isUploadFile: true,
          isNoteEmpty: false,
        };
        if (fileData !== undefined) {
          const { document_title, document_url, reason } = fileData;
          let uploadedList = [];
          if(document_title || document_url) {
            uploadedList = [
              {
                name: document_title,
                url: document_url,
              }
            ]
          }
          obj = Object.assign({}, obj, {
            document_title,
            document_url,
            reason:  uploadedList.length ? '' : reason ,
            fileData,
            fileList: uploadedList ,
            isUploadFile: uploadedList.length ? true : (reason ? false : true),
          });
        }
        return obj;
      });
    },

    goBack() {
      this.isConfirmBackDialog = true;
    },
    hideBackTips(bool, flag) {
      this.isConfirmBackDialog = false;
      if (flag) {
        this.$router.back();
      }
    },

    hideSummitTips(bool, flag) {
      if (flag) {
        this.confirmCallback();
      }
      this.isConfirmSummitDialog = false;
    },
  
    // 上一步
    hideFanhuiTips(bool, flag) {
      if (flag) {
        this.confirmCallback();
      }
      this.isConfirmFanhuiDialog = false;
    },
    
    // 暂时保存
    handleSaveTemp(bool, flag) {
      if (flag) {
        this.confirmCallback();
      }
      this.isSaveTemp = false;
    },

    loadStuList() {
      const paramsData = {
        c_id: this.c_id,
      };
      getFiveScoreInfo(paramsData)
        .then(({ data }) => {
          if (data.code) {
            this.$message.error(data.msg);
            return;
          }
          let { class_info, student_achievement_file_data, student_data } =
            data.result;
          this.classInfo = class_info;
          if (
            student_achievement_file_data &&
            student_achievement_file_data.length
          ) {
            student_achievement_file_data.forEach((item) => {
              student_data.some((stuItem, i) => {
                if (item.user_id === stuItem.user_id) {
                  stuItem.fileData = item;
                }
                return item.user_id === stuItem.user_id;
              });
            });
            this.formVal = student_data;
            this.setRequiredFlag();
          } else {
            this.formVal = student_data;
            this.setRequiredFlag();
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    checkNoteEmpty(row) {
      if (!row.reason) {
        row.isNoteEmpty = true;
      } else {
        row.isNoteEmpty = false;
      }
    },
    handleSwitchChange(val, index) {
      if (val) {
        this.formVal[index].reason = "";
      } else {
        this.formVal[index].document_url = "";
        this.formVal[index].document_title = "";
        this.formVal[index].fileList = [];
      }
    },

    // 删除提交成绩
    handleSocreDocRemove(file, fileList, index) {
      this.formVal[index].document_title = "";
      this.formVal[index].document_url = "";
      this.formVal[index].fileList = [];
    },
    // 删除提交成绩
    handleScoreDocUoloadCheck(file, fileList, index) {
      this.$message.warning(`最多只能上传一个答卷原文件。如果您需要修改已上传文件，请先删除已上传的文件后再重新上传。`);
    },
    beforeUpload(file) {
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error("文件大小不能超过50M!");
        return false;
      }

      if (!/^.*\.(pdf)$/i.test(file.name)) {
        this.$message.error("请上传pdf格式的文件!");
        return false;
      }
      let param = {
        document: file,
      }; // 多此一举？
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },

    handleUploadScoreSuccess(res, file, index) {
      this.formVal[index].document_title = res.result.document_name;
      this.formVal[index].document_url = res.result.document_url;
    },

    // 页面操作
    handlePageAction(actionStatus) {
      this.pageActionStatus = actionStatus;
      // 校验文件
      if (actionStatus === "next") {
        // 校验文字
        let valid = true;
        this.formVal.forEach((item, i) => {
          if (!item.isUploadFile) {
            if (!item.reason) {
              valid = false;
              console.warn(`${i} is validate error`);
            }
          } else {
            if (!item.document_title && !item.document_url) {
              valid = false;
              console.warn(`${i} is validate error`);
            }
          }
        });
        if (valid) {
          this.isConfirmSummitDialog = true;
        } else {
          this.$message.error("请完善所有学员的理论课答卷后再进入下一步");
          console.error("校验失败", this.formVal);
        }
      } else if (actionStatus === "save" ) {
        // 暂时保存
        this.isSaveTemp = true;
      } else if (actionStatus === "back") { // 上一步
        // 暂时保存
        this.isConfirmFanhuiDialog = true;
      }
      // this.Save
    },
    cancelBack() {
      this.isCancel = true;
    },
    hideCanCelTips(bool, flag) {
      this.isCancel = false;
      flag && this.$router.go(-2);
    },
    // 提交表单数据
    confirmCallback() {
      const fileList = this.formVal.map((item) => {
        const { user_id, document_title, document_url, reason } = item;
        return {
          user_id,
          document_title,
          document_url,
          reason,
        };
      });
      const postData = {
        c_id: this.c_id,
        student_achievement_file: JSON.stringify(fileList),
      };
      postFiveStuScoreDoc(postData)
        .then(({ data }) => {
          if (data.code) {
            this.$message.error(data.msg);
            return;
          }
          this.$message.success("成绩报告保存成功");
          let routerPath = "class_report";
          if (this.pageActionStatus === "next") {
            this.$router.push({
              path: routerPath,
              query: {
                c_id: this.c_id,
              },
            });
          } else if (this.pageActionStatus === "save") {
            this.$router.go(-2);
          } else if (this.pageActionStatus === "back") {
            this.$router.go(-1);
          }
          
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    viewDetail(uid) {
      this.stuUid = uid;
      this.ifDiaShow = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
.scoreNav
  flex 1 1 auto
  display flex
  align-items center
  font-size $font_size_big
.scoreMain
  width 100%
  height 100%
  .content
    height 92%
    box-sizing border-box
    padding 15px 0 15px 20px
    background-color $block_bg_color_base
    .five-scrollArea
      height 93% !important
    .scrollArea
      width 100%
      height 100%
      .table
        padding 0 20px 20px 0
        .item
          margin 0 0 20px 0
          .row
            display flex
            position relative
            .col
              flex 1 1 auto
              border-right 1px solid $color_white
              &:last-child
                border-right none
            &.up
              // height: 80px;
              border-bottom 1px solid $color_white
              .col
                // height: 100%;
                &.user
                  width 22%
                  display flex
                  justify-content center
                  align-items center
                  position relative
                  padding-left 8px
                  .num
                    position absolute
                    top 3px
                    left 5px
                  img
                    flex 0 0 auto
                    width 60px
                    height 60px
                    border-radius 50%
                    cursor pointer
                  .wrap
                    // height: 100%;
                    margin 0 0 0 12px
                    display flex
                    flex-direction column
                    justify-content space-around
                    align-items center
                    width 100%
                    .name
                      font-size $font_size_medium
                      // word-break break-word
                      word-break break-all
                      word-wrap break-word
                      margin-bottom 5px
                      width 100%
                      text-align center
                    .btn
                      padding 5px 15px
                      background-color $color_suc
                      border-radius 5px
                      cursor pointer
                      user-select none
                title()
                  flex 0 0 auto
                  width 30px
                  // height: 100%;
                  display flex
                  flex-direction column
                  justify-content center
                  align-items center
                  border-right 1px solid $color_white
                &.info
                  width 30%
                  display flex
                  .title
                    title()
                  .block
                    flex 1 1 auto
                    display flex
                    flex-direction column
                    .line
                      flex 1 1 auto
                      /* padding: 0 0 0 20px; */
                      /* padding: 0 0 0 2px; */
                      display flex
                      align-items center
                      font-size $font_size_base
                      border-bottom 1px solid $color_white
                      &:last-child
                        border-bottom none
                      span:first-child
                        margin 0 5px 0 0
                &.note
                  width 31%
                  display flex
                  align-items center
                  position relative
                  .title
                    title()
                    align-self stretch
                  textarea
                    flex 1 1 auto
                    margin 0 10px
                    color $color_black
                    border-radius 5px
                    outline none
                    resize none
                  .err-tips
                    position absolute
                    bottom -2px
                    left 40px
                    color $color_err
                    font-size $font_size_base
                &.switch-wrapper
                  width 17%
                  display flex
                  align-items center
                  .title
                    title()
                  .btns
                    flex 1 1 auto
                    text-align center
                    font-size $font_size_medium
                &.upload-wrapper
                  width 31%
                  display flex
                  align-items center
                  .title
                    title()
                  .upload-content
                    flex 1
                    overflow hidden
                    text-align center
                    font-size $font_size_medium
                    width 180px
          .nolineTotal
            position absolute
            display flex
            align-items center
            justify-content center
            width 100%
            bottom -60px
        .score-result
          border 1px solid $color_white
          .result-col
            padding 10px 0 10px 10px
            border-right 1px solid $color_white
            &:last-child
              border-right none
  .btns
    height 40px
    margin 10px 0 0
    display flex
    justify-content center
    align-items center
    .btn
      height 100%
      margin 0 20px
      padding 8px 15px
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      line-height $font_size_medium
      border-radius 5px
      cursor pointer
      user-select none
    .success
      background-color $color_suc
    .error
      background-color $color_err
  .preview-score
    /* .score-row {
      border: 1px solid $color_black;
      .score-col {
        text-align: center;
        font-size: $font_size_big;
        border-right: 1px solid $color_black;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:last-child {
          border-right: none;
        }
      }
    }
    .score-head {
      padding: 0 15px;
      .score-row {
        .score-col {
          padding: 5px 0;
          font-weight: bolder;
        }
      }
    }
    .score-body {
      padding: 0 15px;
      .score-row {
        border-top: none;
        &:nth-child(even) {
          background-color: $color_text_placeholder;
        }
      }
    } */
    .scroll-wrap
      display block
      height 630px
      overflow hidden
      position relative
      .table
        padding 0 20px 20px 0
        .item
          margin 0 0 20px 0
          border 1px solid $color_black
          position relative
          .row
            display flex
            .col
              flex 1 1 auto
              border-right 1px solid $color_black
              &:last-child
                border-right none
            &.up
              height 80px
              border-bottom 1px solid $color_black
              .col
                height 100%
                &.user
                  width 22%
                  display flex
                  justify-content center
                  align-items center
                  position relative
                  padding-left 8px
                  .num
                    position absolute
                    top 3px
                    left 5px
                  img
                    flex 0 0 auto
                    width 60px
                    height 60px
                    border-radius 50%
                  .wrap
                    height 100%
                    margin 0 0 0 20px
                    display flex
                    flex-direction column
                    justify-content space-around
                    align-items center
                    width 100%
                    .name
                      font-size $font_size_medium
                      width 100%
                      text-align center
                    .btn
                      padding 5px 15px
                      background-color $color_suc
                      border-radius 5px
                      cursor pointer
                      user-select none
                title()
                  flex 0 0 auto
                  width 30px
                  height 100%
                  display flex
                  flex-direction column
                  justify-content center
                  align-items center
                  border-right 1px solid $color_black
                &.info
                  width 30%
                  display flex
                  .title
                    title()
                  .block
                    flex 1 1 auto
                    display flex
                    flex-direction column
                    .line
                      flex 1 1 auto
                      /* padding: 0 0 0 20px; */
                      /* padding: 0 0 0 2px; */
                      display flex
                      align-items center
                      font-size $font_size_base
                      border-bottom 1px solid $color_black
                      &:last-child
                        border-bottom none
                      span:first-child
                        margin 0 5px 0 0
                &.note
                  width 31%
                  display flex
                  align-items center
                  .title
                    title()
                  textarea
                    flex 1 1 auto
                    margin 0 10px
                    border-radius 5px
                    outline none
                    resize none
                &.switch-wrapper
                  width 17%
                  display flex
                  align-items center
                  .title
                    title()
                  .btns
                    flex 1 1 auto
                    text-align center
                    font-size $font_size_medium
          .nolineTotal
            position absolute
            display flex
            align-items center
            justify-content center
            width 100%
            bottom -60px
        .score-result
          border 1px solid $color_black
          .result-col
            padding 10px 0 10px 10px
            border-right 1px solid $color_black
            &:last-child
              border-right none
  .stu-info
    .scroll-wrap
      display block
      height 530px
      overflow hidden
      position relative
      .stu-info-box
        display block
        padding 0 15px
        font-size $font_size_medium
  .repetition_stu
    border 1px solid $color_err
  .item_border
    border 1px solid $color_white
    position relative
  .exam_border
    margin-top 100px !important
    position relative
    .exam_stu
      position absolute
      width 100%
      top -30px
      display flex
      align-items center
      .dash_line
        width 45%
        height 0
        border 1px dashed $color_white
      .black_boder
        border 1px dashed $color_black
      .dash_content
        font-size 18px
        text-align center
        width 10%
    .totalCommonStu
      position absolute
      width 100%
      top -84px
      display flex
      align-items center
.five-tips
  color $color_unusual
  &:last-child
    margin-bottom 20px
  .tips-item
    margin-right 10px
    &:last-child
      margin-right 0px
.scoreMain
  /deep/.el-switch__label
    span
      color #fff !important
  /deep/.el-switch__label--right
    &.is-active
      span
        color #4cd964 !important
  /deep/.el-switch__label--left
    &.is-active
      span
        color #ccc !important
  /deep/.el-upload-list__item-name
    color #fff !important
.el-upload__tip
  color #fff
</style>
